(function () {
  document.querySelectorAll('[data-premium-accordion]').forEach(function (root) {
    root.querySelectorAll('[data-accordion-head]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('[data-accordion-item]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });
})();
